import CaClinicProfile from "./CaClinicProfile";

export default class CaProfile {
  constructor(
    public readonly caId: string,
    public readonly name: string,
    public readonly email: string,
    public readonly mobile: string,
    public readonly clinics: CaClinicProfile[],
  ) {}
}
